import React from 'react';
import { Consumer as ViewportConsumer, type ViewportContextProps } from '../context';

const withViewportContext =
	<Config,>(
		WrappedComponent: Flow.AbstractComponent<Config & ViewportContextProps>,
	): Flow.AbstractComponent<Config> =>
	// @ts-expect-error - TS2322 - Type '(props: Config) => JSX.Element' is not assignable to type 'AbstractComponent<Config, any>'.
	(props: Config) => (
		<ViewportConsumer>
			{/* @ts-expect-error Spread types may only be created from object types.ts(2698) */}
			{(value) => <WrappedComponent {...props} {...value} />}
		</ViewportConsumer>
	);

export default withViewportContext;
